document.addEventListener("DOMContentLoaded", function() {
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    $('.slideshow').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      fade: true
    });
  } else {
    console.error('Slick slider o jQuery no están cargados.');
  }
});
